export const formatUsd = (value: number, fractionDigits = 2): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number.isFinite(value) ? value : 0);

/**
 * Round a USD amount to cents, half-up — same rule as the backend
 * (api/utils/money.py). Use before comparing a summed float against a limit so
 * 0.1 + 0.2 never reads as over 0.30.
 */
export const roundMoney = (value: number): number => {
  if (!Number.isFinite(value)) return 0;
  const cents = Number((Math.abs(value) * 100).toPrecision(12));
  return (Math.sign(value) * Math.round(cents)) / 100;
};

export const parseDecimal = (raw: string): number => {
  const normalized = raw.replace(',', '.').trim();
  const value = Number.parseFloat(normalized);
  return Number.isFinite(value) ? value : 0;
};
